.field {
  display: flex;
  align-items: center;
  gap: var(--hs-spacing-3);
  height: var(--hs-field-height);
  padding: 0 var(--hs-spacing-4);
  border-radius: var(--hs-radius-full);
  background: var(--hs-color-bg-sunken);
  color: var(--hs-color-text-primary);
  transition:
    background-color 120ms ease,
    box-shadow 120ms ease;
}
/* The ring is on the box, not on the input inside it. */
.field:focus-within {
  background: var(--hs-color-bg-surface);
  box-shadow: var(--hs-focus-lavender);
}
.disabled {
  background: var(--hs-color-bg-muted);
  opacity: 0.5;
}
.lead {
  flex: none;
  color: var(--hs-color-text-secondary);
}
.input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: inherit;
  font: var(--hs-type-body);
}
.input::placeholder {
  color: var(--hs-color-text-tertiary);
  opacity: 1;
}
.input::-webkit-search-cancel-button {
  appearance: none;
}
.voice {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  /* A full touch target around a small glyph. */
  width: 36px;
  height: 36px;
  margin-right: -8px;
  padding: 0;
  border: 0;
  border-radius: var(--hs-radius-full);
  background: transparent;
  color: var(--hs-color-secondary-default);
  cursor: pointer;
}
.voice:hover:not(:disabled) {
  background: var(--hs-color-bg-muted);
}
.voice:focus-visible {
  outline: none;
  box-shadow: var(--hs-focus-olive);
}
.voice:disabled {
  cursor: not-allowed;
}
